<template>
  <div>
    <div class="exercise-knows">
      <el-tag
        v-for="(item, index) in items"
        :key="index"
        closable
        @close="handleClose(index, item)">
        {{item.name}}
      </el-tag>
      <el-button icon="el-icon-plus" size="small" @click="showTabs=!showTabs"></el-button>
    </div>
    <el-tabs v-show="showTabs">
      <el-tab-pane v-for="(tab, key) in tabs" :key="key" :label="tab.title" :name="tab.comp" :lazy="true">
        <component :is="tab.comp" @change="handleSelect"></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import kewen from './../kewen/KewenEntityList'
import word from './../word/WordEntityList'
import grammar from './../grammar/GrammarEntityList'

export default {
  name: 'ExerciseKnows',
  props: {
    value: {
      type: Array,
      default () { return [] }
    },
    eid: Number
  },
  data () {
    return {
      items: this.value,
      tabs: [
        { title: '词汇', comp: 'word' },
        { title: '语言点', comp: 'grammar' },
        { title: '课文', comp: 'kewen' }
      ],
      showTabs: false
    }
  },
  watch: {
    eid (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.items = this.value
      }
    }
  },
  components: { kewen, word, grammar },
  methods: {
    handleClose (index, item) {
      this.items.splice(index, 1)
    },
    handleSelect (item) {
      let name = item.entity.title || item.entity.text
      name = item.type[0].toUpperCase() + ':' + name
      this.items.push({tid: item.entity.id, type: item.type, name: name})
    }
  }
}
</script>

<style lang="scss">
  .exercise-knows{
    margin-right: -8px;
    margin-bottom: -8px;
    > *{
      margin-right: 8px;
      margin-bottom: 8px;
    }
  }
</style>
